import { STORAGE_KEYS } from './constants';

// Save reading progress to localStorage
export const saveReadingProgress = (currentSurah, currentVerse, preferences) => {
  const progressData = {
    surah: currentSurah,
    verse: currentVerse,
    ...preferences,
    timestamp: new Date().toISOString()
  };
  localStorage.setItem(STORAGE_KEYS.PROGRESS, JSON.stringify(progressData));
};

// Load reading progress from localStorage
export const loadReadingProgress = () => {
  const savedProgress = localStorage.getItem(STORAGE_KEYS.PROGRESS);
  if (!savedProgress) return null;
  
  try {
    return JSON.parse(savedProgress);
  } catch (error) {
    console.error("Error parsing saved progress:", error);
    localStorage.removeItem(STORAGE_KEYS.PROGRESS);
    return null;
  }
};
